import React from "react";
import "./Button.css";
import PropTypes from "prop-types";
const PlanButton = ({ onClick, text, style }) => {
  return (
    <div class="text-center">
      <button className="planbutton" onClick={onClick} style={style}>
        {text}
      </button>
    </div>
  );
};
PlanButton.protypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
};
export default PlanButton;
